import React from "react"
import PropTypes from "prop-types"
import {upperFirst} from "lodash"

import {Text, View, Image, StyleSheet} from "@react-pdf/renderer"

const shelfLogo = require("~/images/sabag_logo.png")

const styles = StyleSheet.create({
  container: {
    paddingTop: 50,
    paddingBottom: 100
  },
  image: {width: 120},
  headerText: {
    paddingTop: 20,
    fontSize: 12,
    fontFamily: "Roboto",
    color: "#0D3366"
  }
})

const Header = ({tenantName}) => (
  <View style={styles.container}>
    <Image style={styles.image} src={shelfLogo} />
    <Text style={styles.headerText}>{upperFirst(tenantName)}</Text>
  </View>
)

Header.propTypes = {
  tenantName: PropTypes.string.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/components/pdf/delivery_note/Header.js